module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "key-combo",
      rawName: "v-key-combo",
      value: (['ctrl+shift+k o l o r', 'alt+k o l o r']),
      expression: "['ctrl+shift+k o l o r', 'alt+k o l o r']"
    }],
    staticClass: "app-root wrapper",
    class: _vm.$style.root,
    attrs: {
      "id": "app"
    }
  }, [(_vm.error) ? [_c('p', {
    style: ({
      'color': 'red',
      'margin': '0 auto',
      'font-size': '2em'
    })
  }, [_vm._v("Error")])] : (!_vm.noTemplate) ? [_c('div', {
    staticClass: "cxlt-toastr-container toast-top-right"
  }), (!_vm.loading) ? [_c('dycolor-node'), _c('dycolor-editor', {
    class: {
      "d-none": _vm.hideColorPicker
    },
    on: {
      "close": function($event) {
        _vm.hideColorPicker = true
      }
    }
  }), _c('app-header', {
    attrs: {
      "menuItems": _vm.menuItems,
      "logo": _vm.logo
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)] : _vm._e()] : (!_vm.loading) ? [_c('router-view')] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24f52c2d"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/App.vue
// module id = 2022
// module chunks = 1